import type { Author } from '@/interfaces/author';
import { Badge } from '@dolcevia/ui/components/ui/badge';
import DateFormatter from '@dolcevia/ui/components/ui/date-formatter';
import { ArrowTopRightIcon } from '@radix-ui/react-icons';
import Link from 'next/link';
import CoverImage from './cover-image';

type Props = {
  title: string;
  coverImage: string;
  date: string;
  excerpt: string;
  author: Author;
  slug: string;
  type: string;
};

export function PostPreview({
  title,
  coverImage,
  date,
  excerpt,
  type,
  slug,
}: Props) {
  return (
    <div className="rounded-lg bg-light-yellow p-6 flex flex-col">
      <div className="flex justify-between items-center">
        <div className="flex gap-4 items-center">
          <Badge className="w-max h-max bg-yellow-500">{type}</Badge>
          <DateFormatter dateString={date} formatString="LLLL dd, yyyy" />
        </div>
        <ArrowTopRightIcon className="w-4 h-4" />
      </div>
      <h2 className="text-xl mb-3 leading-snug font-medium text-midnight-100">
        <Link
          as={`/posts/${slug}`}
          href="/posts/[slug]"
          className="hover:underline"
        >
          {title}
        </Link>
      </h2>

      <p className="text-lg leading-relaxed mb-4 line-clamp-3">{excerpt}</p>
      <CoverImage
        className="h-[200px]"
        slug={slug}
        title={title}
        src={coverImage}
      />
    </div>
  );
}
